import { createTheme, Drawer, type MantineColorsTuple } from '@mantine/core';

const colors: MantineColorsTuple = [
  '#f1f4f9',
  '#e1e5eb',
  '#bfc9d9',
  '#9aacc7',
  '#7b93b8',
  '#6783af',
  '#5c7bac',
  '#4c6997',
  '#425e88',
  '#2c4466',
];

export const theme = createTheme({
  colors: {
    colors,
  },
  primaryColor: 'colors',
  fontFamily: 'mundial, sans-serif',
  components: {
    Drawer: Drawer.extend({
      styles: {
        title: {
          fontWeight: 700,
          fontSize: '1.2rem',
        },
      },
    }),
  },
});
